<template>
  <div>
    <v-card>
      <div class="pa-2 d-print-none">
        <v-row no-gutters class="align-center">
          <v-col cols="12" md="9">
            <h2 class="px-2">{{ count }} {{ $t("credit") }}</h2>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>

      <v-data-table
        :headers="headers"
        :items="historic"
        item-key="name"
        class="elevation-1"
        :search="search"
        ref="dataTable"
        @update:page="$vuetify.goTo($refs.dataTable)"
        @pagination="updateCount"
      >
        <template v-slot:item.date_sales="{ item }">
          {{ item.date_sales | dateFormat }}
        </template>
        <template v-slot:item.status_sales="{ item }">
          {{ item.status_sales == "1" ? $t("active") : $t("inactive") }}
        </template>
      </v-data-table>
    </v-card>
    <div class="mt-4">
      <Resume
        :data_resume="{
          data: this.historic,
          keys: ['value_sale', 'value_comission'],
          showSum: true,
          hideAlert: true,
        }"
      />
    </div>
  </div>
</template>

<script>
import Resume from "@/components/backoffice/resume_global/resume";
export default {
  name: "AgentCreditHistoric",
  components: {
    Resume,
  },
  data() {
    return {
      search: "",
      historic: [],
      count: 0,
    };
  },
  mounted() {
    this.historicSales();
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("code"),
          align: "start",
          sortable: false,
          value: "id_sale",
        },
        {
          text: this.$t("simpleTableOperation"),
          value: "name_operation",
          sortable: false,
        },
        { text: this.$t("value"), value: "value_sale" },
        { text: this.$t("sumComission"), value: "value_comission" },
        { text: this.$t("listBetOnlineHeaderDateHour"), value: "date_sales" },
        { text: this.$t("client"), value: "name_player" },
        { text: this.$t("status"), value: "status_sales" },
      ];
    },
    // Global Filters
    rangeGlobalDate() {
      return this.$store.state.rangeGlobal.date;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.historicSales();
    },
  },
  methods: {
    // Count Sales Credit
    updateCount(items) {
      this.count = items.itemsLength;
    },

    historicSales() {
      this.$request
        .post("/agent/credits/historicSales", {
          ...this.rangeGlobalDate,
        })
        .then((resp) => {
          this.historic = resp.data.dados.map((element) => {
            element.value_comission = Number(element.value_comission) * -1;
            return element;
          });
        })
        .catch(() => {
          this.historic = [];
        });
    },
  },

  filters: {
    dateFormat: function (val) {
      var date = new Date(val.replace(" ", "T")).toLocaleString();
      return date;
    },
  },
};
</script>
